import { render, staticRenderFns } from "./SkuDonut.vue?vue&type=template&id=31925d64&scoped=true"
import script from "./SkuDonut.vue?vue&type=script&lang=js"
export * from "./SkuDonut.vue?vue&type=script&lang=js"
import style0 from "./SkuDonut.vue?vue&type=style&index=0&id=31925d64&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31925d64",
  null
  
)

export default component.exports